import Actions from './Actions';
import Body from './Body';
import CloseButton from './CloseButton';
import Content, { type ContentProps } from './Content';
import Header from './Header';
import Root, {
  type BaseDialogProps,
  type ControlledDialogProps,
  type RootHandlers,
  type RootProps,
  type StaticDialogProps,
} from './Root';
import Subtitle from './Subtitle';
import Title from './Title';
import Trigger from './Trigger';

export type { RootHandlers as DialogRootHandlers };
export type { RootProps as DialogRootProps };
export type { ControlledDialogProps as DialogControlledProps };
export type { StaticDialogProps as DialogStaticProps };
export type { BaseDialogProps as DialogBaseProps };
export type { ContentProps as DialogContentProps };

export const DialogComposite = {
  Root,
  Content,
  Header,
  Title,
  Subtitle,
  CloseButton,
  Body,
  Actions,
  Trigger,
};
